import React, { useState } from 'react';
import './Header.css';

interface HeaderProps {
  name: string;
  searchPlaceholder: string;
  onCreateClick: () => void;
  onCreateWithText?: (text: string) => void;
}

const Header: React.FC<HeaderProps> = ({ name, searchPlaceholder, onCreateClick, onCreateWithText }) => {
  const [searchText, setSearchText] = useState('');

  const handleCreateClick = () => {
    console.log('Header: Create clicked with text:', searchText);
    if (searchText.trim() && onCreateWithText) {
      console.log('Header: Calling onCreateWithText with:', searchText.trim());
      onCreateWithText(searchText.trim());
      setSearchText(''); // Clear the search box
    } else {
      console.log('Header: Calling default onCreateClick');
      onCreateClick(); // Default behavior if no text
    }
  };
  return (
    <header className="header">
      <nav className="nav">
        <div className="logo">{name}</div>
        <div className="nav-links">
          <input 
            type="text" 
            className="search-bar" 
            placeholder={searchPlaceholder}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleCreateClick()}
          />
          <button className="create-btn" onClick={handleCreateClick}>
            Create
          </button>
          <div className="profile-avatar"></div>
        </div>
      </nav>
      <div className="header-subtitle">
        Do you see the 'i' and 'click to chat' buttons on cards? YOU SHOULD CLICK ON THEM. I'll be there to chat on the canvas (and sometimes my AI). A lot of fun and stories though. Let's go.
      </div>
    </header>
  );
};

export default Header;